// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1re1x","header":"MessagesList_header__YrTGN","chat":"MessagesList_chat__Uda2i"};